import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12h8","key":"svg-0"}],["path",{"d":"M14 12h8","key":"svg-1"}],["path",{"d":"M10 5v14","key":"svg-2"}],["path",{"d":"M14 9v6","key":"svg-3"}]]

/**
 * IconCircuitCell
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY3VpdC1jZWxsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yIDEyaDgiIC8+CiAgPHBhdGggZD0iTTE0IDEyaDgiIC8+CiAgPHBhdGggZD0iTTEwIDV2MTQiIC8+CiAgPHBhdGggZD0iTTE0IDl2NiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/circuit-cell
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircuitCell = createReactComponent('outline', 'circuit-cell', 'CircuitCell', __iconNode);

export default IconCircuitCell;